import { createBehavior } from '@area17/a17-behaviors';

const clock = createBehavior(
  'clock',
  {
    setTime() {
      const minutes = this.time.minute;
      const hours = this.time.hour % 12;

      if (minutes === 0) {
        this.rotations[0]++;
      }

      if (hours === 0 && minutes === 0) {
        this.rotations[1]++;
      }

      const minutesDeg = (minutes / 60) * 360 + this.rotations[0] * 360;
      const hoursDeg =
        (hours / 12) * 360 + (minutes / 60) * 30 + this.rotations[1] * 360;

      this.$minuteHand.style.transform = `rotate(${minutesDeg}deg)`;
      this.$hourHand.style.transform = `rotate(${hoursDeg}deg)`;
    },
  },
  {
    init() {
      this.rotations = [0, 0]; // [minutes, hours]
      this.$minuteHand = this.getChild('minute-hand');
      this.$hourHand = this.getChild('hour-hand');

      (async () => {
        const { DateTime } = await import('luxon');

        this.timezoneName = this.options['timezone-name'];

        this.time = DateTime.local();
        if (this.timezoneName) {
          this.time = this.time.setZone(this.timezoneName);
        }

        this.setTime();
        this.interval = setInterval(() => {
          this.setTime();
        }, 1000);
      })();
    },
    destroy() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    },
  }
);

export default clock;
